import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const Card = styled.div`
  position: relative;
  width: 520px;
  max-width: 100%;
  max-height: 92vh;
  overflow-y: auto;
  padding: 30px;
  border-radius: 6px;
  background: #FCFEFC;
  box-shadow: 0px 2px 3px 0px rgba(36, 36, 36, 0.10);

  .top{
    display: flex;
    align-items: center;
    gap: 8px;
    padding-right: 28px;

    h3{
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      line-height: 120%;
      color: #4D4F50;
    }

    .pro{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 23px;
      padding: 0 12px;
      color: #fff;
      font-size: 12px;
      border-radius: 12px;
      background: #2AA444;
    }
  }

  .close{
    position: absolute;
    top: 30px;
    right: 30px;
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
  }

  .intro{
    margin-top: 12px;
    font-size: 13px;
    line-height: 150%;
    color: #4D4F50;
  }

  .beneficios{
    margin: 12px 0 4px;
    padding-left: 18px;
    font-size: 13px;
    line-height: 160%;
    color: #4D4F50;
  }

  .linha{
    display: flex;
    align-items: flex-end;
    gap: 12px;
    > .form-group{ flex: 1; min-width: 0; }
  }

  textarea{
    min-height: 96px;
    resize: vertical;
  }

  .contador{
    align-self: flex-end;
    font-size: 11px;
    color: #4D4F50;
    margin-top: 2px;
  }

  .acoes{
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;

    button{
      margin: 0;
      cursor: pointer;
      border-radius: 4px;
    }

    .secundario{
      background: transparent;
      color: var(--primary-color);
      border: 1.2px solid var(--primary-color);
    }
  }

  .geral{
    color: #C43333;
    font-size: 12px;
    margin-top: 10px;
  }

  .estado{
    margin-top: 18px;
    padding: 16px;
    border-radius: 8px;
    font-size: 14px;
    line-height: 150%;
    color: #4D4F50;
    background: #F1F8F2;
    border: 1px solid #CFE6D3;

    strong{ display: block; margin-bottom: 4px; color: #1f7a33; }

    &.recusada{
      background: #FDF3F3;
      border-color: #F0CACA;
      strong{ color: #C43333; }
    }
  }

  .carregando{
    margin-top: 24px;
    text-align: center;
    color: #4D4F50;
    font-size: 14px;
  }
`;
